// extracted by mini-css-extract-plugin
var _1 = "DashboardSeverityDot-moduledot__ANNrJ";
var _2 = "DashboardSeverityDot-moduleerror__jyLie";
var _3 = "DashboardSeverityDot-modulewarning__Owrt0";
export { _1 as "dot", _2 as "error", _3 as "warning" }
